import { apiSlice } from '../api/apiSlice';
import {
    GetNotificationListParams,
    GetNotificationListResponse,
} from './notificationApiSliceTypes';

const notificationApiSlice = apiSlice.injectEndpoints({
    endpoints: (builder) => ({
        getNotifications: builder.query<
            GetNotificationListResponse,
            GetNotificationListParams
        >({
            query: (params) => ({
                url: '/notifications',
                method: 'GET',
                params: {
                    page: params?.page ?? 1,
                    limit: params?.limit ?? 10,
                },
            }),
        }),

        markAsRead: builder.mutation({
            query: (params) => ({
                url: `/notifications/${params.id}/read`,
                method: 'PATCH',
                headers: {
                    'Accept-Language': params.language ?? 'en',
                },
            }),
        }),
    }),

    overrideExisting: true,
});

export const { useLazyGetNotificationsQuery, useMarkAsReadMutation } =
    notificationApiSlice;
